import { createGlobalStyle } from 'styled-components'

const Variables = createGlobalStyle`

:root {
    //! Colors
    --black: ${(props) => props.theme.colors.black};
    --white: ${(props) => props.theme.colors.white};
    --red: ${(props) => props.theme.colors.red};
    --cream: ${(props) => props.theme.colors.cream};
    --darkCream: ${(props) => props.theme.colors.darkCream};
    --green: ${(props) => props.theme.colors.green};
    --orange: ${(props) => props.theme.colors.orange};
    --dirtGreen: ${(props) => props.theme.colors.dirtGreen};
    --grey: ${(props) => props.theme.colors.grey};

    //! Screen Sizes
    --DesktopSizeL: ${(props) => props.theme.mediaQuery.DesktopSizeL};
    --DesktopSizeS: ${(props) => props.theme.mediaQuery.DesktopSizeS};
    --DesktopSizeXS: ${(props) => props.theme.mediaQuery.DesktopSizeXS};
    --LaptopSize: ${(props) => props.theme.mediaQuery.LaptopSize};
    --TabletSize: ${(props) => props.theme.mediaQuery.TabletSize};
    --MobileSize: ${(props) => props.theme.mediaQuery.MobileSize};

    //! Spacing
    --spSize: 8px;
    
    --sp0-5x: calc(var(--spSize) * 0.5);
    --sp0-6x: calc(var(--spSize) * 0.6);
    --sp0-75x: calc(var(--spSize) * 0.75);
    --sp1x: calc(var(--spSize));
    --sp1-1x: calc(var(--spSize) * 1.1);
    --sp1-25x: calc(var(--spSize) * 1.25);
    --sp1-3x: calc(var(--spSize) * 1.3);
    --sp1-4x: calc(var(--spSize) * 1.4);
    --sp1-5x: calc(var(--spSize) * 1.5);
    --sp1-6x: calc(var(--spSize) * 1.6);
    --sp1-75x: calc(var(--spSize) * 1.75);
    --sp2x: calc(var(--spSize) * 2);
    --sp2-5x: calc(var(--spSize) * 2.5);
    --sp3x: calc(var(--spSize) * 3);
    --sp3-5x: calc(var(--spSize) * 3.5);
    --sp4x: calc(var(--spSize) * 4);
    --sp4-5x: calc(var(--spSize) * 4.5);
    --sp5x: calc(var(--spSize) * 5);
    --sp5-5x: calc(var(--spSize) * 5.5);
    --sp6x: calc(var(--spSize) * 6);
    --sp6-5x: calc(var(--spSize) * 6.5);
    --sp7x: calc(var(--spSize) * 7);
    --sp7-5x: calc(var(--spSize) * 7.5);
    --sp8x: calc(var(--spSize) * 8);
    --sp8-5x: calc(var(--spSize) * 8.5);
    --sp9x: calc(var(--spSize) * 9);
    --sp9-5x: calc(var(--spSize) * 9.5);
    --sp10x: calc(var(--spSize) * 10);
    --sp10-5x: calc(var(--spSize) * 10.5);
    --sp11x: calc(var(--spSize) * 11);
    --sp11-5x: calc(var(--spSize) * 11.5);
    --sp12x: calc(var(--spSize) * 12);
    --sp12-5x: calc(var(--spSize) * 12.5);
    --sp13x: calc(var(--spSize) * 13);
    --sp14x: calc(var(--spSize) * 14);
    --sp14-5x: calc(var(--spSize) * 14.5);
    --sp15x: calc(var(--spSize) * 15);
    --sp16x: calc(var(--spSize) * 16);
    --sp17x: calc(var(--spSize) * 17);
    --sp17-5x: calc(var(--spSize) * 17.5);
    --sp18x: calc(var(--spSize) * 18);
    --sp19x: calc(var(--spSize) * 19);
    --sp19-5x: calc(var(--spSize) * 19.5);
    --sp20x: calc(var(--spSize) * 20);
    --sp21x: calc(var(--spSize) * 21);
    --sp22x: calc(var(--spSize) * 22);
    --sp22-5x: calc(var(--spSize) * 22.5);
    --sp23x: calc(var(--spSize) * 23);
    --sp24x: calc(var(--spSize) * 24);
    --sp25x: calc(var(--spSize) * 25);
    --sp26x: calc(var(--spSize) * 26);
    --sp27x: calc(var(--spSize) * 27);
    --sp27-5x: calc(var(--spSize) * 27.5);
    --sp28x: calc(var(--spSize) * 28);
    --sp29x: calc(var(--spSize) * 29);
    --sp29-5x: calc(var(--spSize) * 29.5);
    --sp30x: calc(var(--spSize) * 30);
    --sp31x: calc(var(--spSize) * 31);
    --sp32x: calc(var(--spSize) * 32);
    --sp33x: calc(var(--spSize) * 33);
    --sp34x: calc(var(--spSize) * 34);
    --sp35x: calc(var(--spSize) * 35);
    --sp36x: calc(var(--spSize) * 36);
    --sp37x: calc(var(--spSize) * 37);
    --sp37-5x: calc(var(--spSize) * 37.5);
    --sp38x: calc(var(--spSize) * 38);
    --sp39x: calc(var(--spSize) * 39);
    --sp40x: calc(var(--spSize) * 40);
    --sp41x: calc(var(--spSize) * 41);
    --sp42x: calc(var(--spSize) * 42);
    --sp43x: calc(var(--spSize) * 43);
    --sp44x: calc(var(--spSize) * 44);
    --sp44-5x: calc(var(--spSize) * 44.5);
    --sp45x: calc(var(--spSize) * 45);
    --sp46x: calc(var(--spSize) * 46);
    --sp47x: calc(var(--spSize) * 47);
    --sp48x: calc(var(--spSize) * 48);
    --sp49x: calc(var(--spSize) * 49);
    --sp50x: calc(var(--spSize) * 50);
    --sp51x: calc(var(--spSize) * 51);
    --sp52x: calc(var(--spSize) * 52);
    --sp53x: calc(var(--spSize) * 53);
    --sp54x: calc(var(--spSize) * 54);
    --sp55x: calc(var(--spSize) * 55);
    --sp56x: calc(var(--spSize) * 56);
    --sp57x: calc(var(--spSize) * 57);
    --sp58x: calc(var(--spSize) * 58);
    --sp59x: calc(var(--spSize) * 59);
    --sp60x: calc(var(--spSize) * 60);
    --sp61x: calc(var(--spSize) * 61);
    --sp62x: calc(var(--spSize) * 62);
    --sp62-5x: calc(var(--spSize) * 62.5);
    --sp63x: calc(var(--spSize) * 63);
    --sp64x: calc(var(--spSize) * 64);
    --sp65x: calc(var(--spSize) * 65);
    --sp66x: calc(var(--spSize) * 66);
    --sp67x: calc(var(--spSize) * 67);
    --sp68x: calc(var(--spSize) * 68);
    --sp69x: calc(var(--spSize) * 69);
    --sp70x: calc(var(--spSize) * 70);
    --sp72x: calc(var(--spSize) * 72);
    --sp73x: calc(var(--spSize) * 73);
    --sp74x: calc(var(--spSize) * 74);
    --sp75x: calc(var(--spSize) * 75);
    --sp76x: calc(var(--spSize) * 76);
    --sp77x: calc(var(--spSize) * 77);
    --sp78x: calc(var(--spSize) * 78);
    --sp79x: calc(var(--spSize) * 79);
    --sp80x: calc(var(--spSize) * 80);
    --sp81x: calc(var(--spSize) * 81);
    --sp82x: calc(var(--spSize) * 82);
    --sp83x: calc(var(--spSize) * 83);
    --sp84x: calc(var(--spSize) * 84);
    --sp85x: calc(var(--spSize) * 85);
    --sp86x: calc(var(--spSize) * 86);
    --sp87x: calc(var(--spSize) * 87);
    --sp87-5x: calc(var(--spSize) * 87.5);
    --sp88x: calc(var(--spSize) * 88);
    --sp89x: calc(var(--spSize) * 89);
    --sp90x: calc(var(--spSize) * 90);
    --sp91x: calc(var(--spSize) * 91);
    --sp92x: calc(var(--spSize) * 92);
    --sp93x: calc(var(--spSize) * 93);
    --sp94x: calc(var(--spSize) * 94);
    --sp96x: calc(var(--spSize) * 96);
    --sp97x: calc(var(--spSize) * 97);
    --sp98x: calc(var(--spSize) * 98);
    --sp99x: calc(var(--spSize) * 99);
    --sp100x: calc(var(--spSize) * 100);
    --sp101x: calc(var(--spSize) * 101);
    --sp102x: calc(var(--spSize) * 102);
    --sp103x: calc(var(--spSize) * 103);
    --sp104x: calc(var(--spSize) * 104);
    --sp106x: calc(var(--spSize) * 106);
    --sp107x: calc(var(--spSize) * 107);
    --sp108x: calc(var(--spSize) * 108);
    --sp110x: calc(var(--spSize) * 110);
    --sp111x: calc(var(--spSize) * 111);
    --sp112x: calc(var(--spSize) * 112);
    --sp113x: calc(var(--spSize) * 113);
    --sp115x: calc(var(--spSize) * 115);
    --sp117x: calc(var(--spSize) * 117);
    --sp118x: calc(var(--spSize) * 118);
    --sp119x: calc(var(--spSize) * 119);
    --sp120x: calc(var(--spSize) * 120);
    --sp125x: calc(var(--spSize) * 125);
    --sp128x: calc(var(--spSize) * 128);
    --sp129x: calc(var(--spSize) * 129);
    --sp123x: calc(var(--spSize) * 123);
    --sp132x: calc(var(--spSize) * 132);
    --sp135x: calc(var(--spSize) * 135);
    --sp136x: calc(var(--spSize) * 136);
    --sp138x: calc(var(--spSize) * 138);
    --sp140x: calc(var(--spSize) * 140);
    --sp141x: calc(var(--spSize) * 141);
    --sp142x: calc(var(--spSize) * 142);
    --sp143x: calc(var(--spSize) * 143);
    --sp145x: calc(var(--spSize) * 145);
    --sp146x: calc(var(--spSize) * 146);
    --sp148x: calc(var(--spSize) * 148);
    --sp149x: calc(var(--spSize) * 149);
    --sp150x: calc(var(--spSize) * 150);
    --sp152x: calc(var(--spSize) * 152);
    --sp153x: calc(var(--spSize) * 153);
    --sp157x: calc(var(--spSize) * 157);
    --sp159x: calc(var(--spSize) * 159);
    --sp161x: calc(var(--spSize) * 161);
    --sp164x: calc(var(--spSize) * 164);
    --sp166x: calc(var(--spSize) * 166);
    --sp167x: calc(var(--spSize) * 167);
    --sp168x: calc(var(--spSize) * 168);
    --sp169x: calc(var(--spSize) * 169);
    --sp170x: calc(var(--spSize) * 170);
    --sp171x: calc(var(--spSize) * 171);
    --sp175x: calc(var(--spSize) * 175);
    --sp180x: calc(var(--spSize) * 180);
    --sp182x: calc(var(--spSize) * 182);
    --sp185x: calc(var(--spSize) * 185);
    --sp200x: calc(var(--spSize) * 200);
    --sp201x: calc(var(--spSize) * 201);
    --sp210x: calc(var(--spSize) * 210);
    --sp221x: calc(var(--spSize) * 221);

    //! transition
    --trTime: 0.3s;
    --trTime2: 0.4s;
    --trTime3: 0.5s;
    --trTime4: 0.7s;
    --trTime5: 1s;

    //! line heights
    --lineHeightSuperMin: 0.8;
    --lineHeightMin: 1.2;
    --lineHeightMax: 1.5;

    //! cont
    --maxWidth: 100%;

    //! Product 
    --productOverIconPosition: var(--sp3x);
}

@media only screen and  (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
    :root {
        --big: 424px;
        --h1: 176px;
        --h2: 160px;
        --h3: 112px;
        --h4: 96px;
        --h5: 88px;
        --h6: 64px;
        --h7: 48px;
        --h8: 40px;
        --h9: 32px;
        --h10: 24px;
        --p:20px;
        --mini: 16px;

        //! Section margin 
        --sectionMargin: var(--sp30x);
        --titleMargin: var(--sp13x);

        //! Button margin
        --fancyButtonMargin: var(--sp13x);
        --buttonMargin: var(--sp10x);

        //! Page margin
        --pageMarginTop: var(--sp12x);
        --pageMarginBottom: var(--sp30x);

        //! Grid 
        --containerPadding: var(--sp14x);
        --containerLargePadding: var(--sp58x);

        //! Product 
        --productOverIconPosition: var(--sp5x);
    }
}


@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {

    :root {
        --big: 312px;
        --h1: 140px;
        --h2: 120px;
        --h3: 88px;
        --h4: 72px;
        --h5: 64px;
        --h6: 56px;
        --h7: 40px;
        --h8: 32px;
        --h9: 24px;
        --h10: 20px;
        --p: 16px;
        --mini: 14px;

        //! Section margin 
        --sectionMargin: var(--sp25x);
        --titleMargin: var(--sp10x);

        //! Button margin
        --fancyButtonMargin: var(--sp10x);
        --buttonMargin: var(--sp8x);

        //! Page margin
        --pageMarginTop: var(--sp10x);
        --pageMarginBottom: var(--sp25x);

        //! Grid 
        --containerPadding: var(--sp11x);
        --containerLargePadding: var(--sp45x);

        //! Product 
        --productOverIconPosition: var(--sp3x);
    }
}

@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
    :root {
        --big: 264px;
        --h1: 96px;
        --h2: 88px;
        --h3: 64px;
        --h4: 56px;
        --h5: 48px;
        --h6: 48px;
        --h7: 32px;
        --h8: 24px;
        --h9: 20px;
        --h10: 16px;
        --p: 16px;
        --mini: 12px;

        //! Section margin 
        --sectionMargin: var(--sp22-5x);
        --titleMargin: var(--sp8x);

        //! Button margin
        --fancyButtonMargin: var(--sp8x);
        --buttonMargin: var(--sp7x);

        //! Page margin
        --pageMarginTop: var(--sp8x);
        --pageMarginBottom: var(--sp22x);

        //! Grid 
        --containerPadding: var(--sp9x);
        --containerLargePadding: var(--sp33x);

        //! Product 
        --productOverIconPosition: var(--sp3x);
    }
}

@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.LaptopSize}) {
    :root {
        --big: 216px;
        --h1: 72px;
        --h2: 64px;
        --h3: 56px;
        --h4: 48px;
        --h5: 40px;
        --h6: 32px;
        --h7: 24px;
        --h8: 20px;
        --h9: 16px;
        --h10: 16px;
        --p: 16px;
        --mini: 12px;

        //! Section margin 
        --sectionMargin: var(--sp17-5x);
        --titleMargin: var(--sp7x);

        //! Button margin
        --fancyButtonMargin: var(--sp7x);
        --buttonMargin: var(--sp6x);

        //! Page margin
        --pageMarginTop: var(--sp7x);
        --pageMarginBottom: var(--sp17x);

        //! Grid 
        --containerPadding: var(--sp5x);
        --containerLargePadding: var(--sp16x);

        //! Product 
        --productOverIconPosition: var(--sp2x);
    }
}

@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
    :root {
        --big: 216px;
        --h1: 72px;
        --h2: 64px;
        --h3: 56px;
        --h4: 48px;
        --h5: 40px;
        --h6: 32px;
        --h7: 24px;
        --h8: 20px;
        --h9: 16px;
        --h10: 16px;
        --p: 16px;
        --mini: 12px;

        //! Section margin 
        --sectionMargin: var(--sp17-5x);
        --titleMargin: var(--sp7x);

        //! Button margin
        --fancyButtonMargin: var(--sp7x);
        --buttonMargin: var(--sp6x);

        //! Page margin
        --pageMarginTop: var(--sp7x);
        --pageMarginBottom: var(--sp17x);

        //! grid 
        --containerPadding: var(--sp4x);
        --containerLargePadding: var(--sp12x);

        //! Product 
        --productOverIconPosition: var(--sp2x);
    }
}

@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
    :root {
        --big: 120px;
        --h1: 40px;
        --h2: 32px;
        --h3: 40px;
        --h4: 32px;
        --h5: 32px;
        --h6: 24px;
        --h7: 20px;
        --h8: 20px;
        --h9: 16px;
        --h10: 16px;
        --p: 14px;
        --mini: 12px;

        //! Section margin 
        --sectionMargin: var(--sp15x);
        --titleMargin: var(--sp5x);

        //! Button margin
        --fancyButtonMargin: var(--sp5x);
        --buttonMargin: var(--sp5x);

        //! Page margin
        --pageMarginTop: var(--sp5x);
        --pageMarginBottom: var(--sp12x);

        //! Grid 
        --containerPadding: var(--sp2-5x);
        --containerLargePadding: var(--sp3x);

        //! Product 
        --productOverIconPosition: var(--sp2x);
    }
}
`

export default Variables
